import React, {Fragment} from "react";
import logoReamaze from 'components/images/logos/logo_reamaze.png'
import useReamazeSetup from "./useReamazeSetup";
import ReamazeSetupModal from "./ReamazeSetupModal";
import ChannelCard from "../../Utilities/ChannelCard";

export default function ReamazeProvider() {
	const { initiateReamazeSetup, reamazeSetupOpen, handleReamazeSetupOpen, handleReamazeSetupClose } = useReamazeSetup()

	return (
		<Fragment>
			<ChannelCard
				icon={logoReamaze}
				label={'Reamaze'}
				description={'Resolve support tickets and clear your backlog'}
				onClick={initiateReamazeSetup}
			/>

			<ReamazeSetupModal
				open={reamazeSetupOpen}
				handleOpen={handleReamazeSetupOpen}
				handleClose={handleReamazeSetupClose}
			/>
		</Fragment>
	)
}